const de = {
  indexIndicatorSep: ' von ',
  errorMsg: 'Der Inhalt konnte nicht geladen werden.',
  closeTitle: 'Schließen',
  zoomTitle: 'Zoom',
  arrowPrevTitle: 'Vorheriges Bild',
  arrowNextTitle: 'Nächstes Bild',
  defaultDialogTitle: 'Detailansicht',
};

export { de };
